/**
 * Side-effect-free deep entry for the lib's standalone directives.
 *
 * App code (and specs) should import directives from
 * `@newgenus/angular-shared-components/directives`, NOT the main barrel: the
 * barrel transitively pulls `@newgenus/common`, whose every-moment side-effect
 * import throws under jest (see CLAUDE.md §TypeScript Conventions).
 */
export * from './resize-observer.directive';
export * from './sheet-drag-dismiss.directive';
